module.exports = __webpack_public_path__ + "media/img/email/TAKMAPS_blk-fba78922260f49453d71226966f3f3d0.png";